import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import { withTranslation } from 'react-i18next';

import './Modal.scss';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    borderRadius: '8px',
    padding: '24px',
    transform: 'translate(-50%, -50%)',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
};

class Modal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      content: props.modalContent,
    };

    this.closeModal = this.closeModal.bind(this);
    this.getContent = this.getContent.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open) {
      this.setState({
        modalIsOpen: this.props.open,
      });
    }
  }

  getContent() {
    if (this.props.doubleStep) {
      return (
        <div className="text-center">
          <h4>{this.props.t(this.state.content + '.confirmTitle')}</h4>
          <p>{this.props.t(this.state.content + '.confirmMessage')}</p>
          <button className="btn btn-warn" onClick={this.closeModal}>
            {this.props.t(this.state.content + '.labelContinue')}
          </button>
        </div>
      );
    }
    return (
      <div className={`modal-container ${this.props.customClass || ''}`}>
        {!this.props.hideIcon && (
          <span className="warning-size in-active-color">
            <i className="fa fa-exclamation-circle"></i>
          </span>
        )}
        <h4 className="text-center">{this.props.t(this.state.content + '.question')}</h4>
        <p className="text-center">{this.props.t(this.state.content + '.message')}</p>
        <div className="buttons-container w-100">
          <button className="btn btn-warn" onClick={this.closeModal}>
            {this.props.t(this.state.content + '.labelCancel')}
          </button>
          <button
            className={`btn ${this.props.hasRemoveButton ? 'btn-remove' : 'btn-action'}`}
            onClick={this.props.onConfirm}>
            {this.props.t(this.state.content + '.labelConfirm')}
          </button>
        </div>
      </div>
    );
  }

  closeModal() {
    this.setState({
      modalIsOpen: false,
    });
    this.props.closeModal();
  }

  render() {
    return (
      <ReactModal
        isOpen={this.state.modalIsOpen}
        onRequestClose={this.closeModal}
        style={customStyles}
        shouldCloseOnOverlayClick={false}
        ariaHideApp={false}
        contentLabel="Modal">
        {this.getContent()}
      </ReactModal>
    );
  }
}

Modal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  modalContent: PropTypes.string.isRequired,
  doubleStep: PropTypes.bool,
  customClass: PropTypes.string,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(Modal);
